export class TokenEndpointError extends Error {
  public readonly response: Response;

  public readonly status: number;

  constructor(message: string, response: Response) {
    super(message);
    this.name = 'TokenEndpointError';
    this.response = response;
    this.status = response.status;
    Object.setPrototypeOf(this, TokenEndpointError.prototype);
  }
}
